<template>
    <div class="patient-forgot-page">
        <b-container>
            <b-row align-h="center">
                <b-col cols="6">
                    <h2>Patient Forgot Password</h2>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="6">
                    <p>{{message}}</p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    export default
    {
        name: 'Patient-Forgot-Password',
        data ()
        {
            return {
                message: "Please contact customer support with your ID in order to have a new password issued."
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/patient/patient-forgot-password.vue